'use client'
import dynamic from 'next/dynamic'
import { Suspense } from 'react'

const DynamicTechnologyBasedProducts = dynamic(
  () =>
    import('./technology-based-products').then(
      (m) => m.TechnologyBasedProducts
    ),
  { ssr: false }
)
const DynamicFabricTechnologyShowcase = dynamic(
  () =>
    import('@/components/common/home/fabric-technology-showcase').then(
      (m) => m.FabricTechnologyShowcase
    ),
  { ssr: false }
)

export function ProductDetailClientSections({
  productId,
}: {
  productId: string
}) {
  return (
    <>
      <Suspense fallback={null}>
        <DynamicTechnologyBasedProducts productId={productId} />
      </Suspense>
      <Suspense fallback={null}>
        <DynamicFabricTechnologyShowcase />
      </Suspense>
    </>
  )
}
